import PropTypes from "prop-types";
import React, { Component } from "react";
import Wizard from "../components/Wizard";
import { withStyles } from "@material-ui/core";

const styles = () => ({
  wizard: {
    position: "relative",
    height: "100%"
  }
});

class Content extends Component {
  render() {
    const { classes, isOpenSideBar, toggleSideBar, isShowBtnInfo } = this.props;
    return (
      <Wizard
        toggleSideBar={toggleSideBar}
        isOpenSideBar={isOpenSideBar}
        isShowBtnInfo={isShowBtnInfo}
        className={classes.wizard}
      />
    );
  }
}

Content.propTypes = {
  classes: PropTypes.shape({
    wizard: PropTypes.any
  }),
  isOpenSideBar: PropTypes.bool,
  isShowBtnInfo: PropTypes.bool,
  toggleSideBar: PropTypes.func
};

export default withStyles(styles)(Content);
